import { create } from "zustand";
export const useSearchStore = create((set, get) => {
    let timeout = null;
    return {
        inputValue: "",
        searchValue: "",
        setInputValue: (value) => {
            // update input immediately
            set({ inputValue: value });
            // clear old timer
            if (timeout)
                clearTimeout(timeout);
            // set new timer for 1s
            timeout = setTimeout(() => {
                console.log({ "get().inputValue:": get().inputValue });
                set({ searchValue: get().inputValue });
            }, 1000);
        },
        movieId: "",
        setMovieId: (value) => set({ movieId: value }),
    };
});
